import { Emitter, Event } from "../../../../features/event-emitter"
import { ImportPriceField, useImportProductPrices } from "../../../../features/importer"

export const useActions = () => {
    const importProductPrices = useImportProductPrices()

    const updatePrices = async (file: File, priceFieldValue: ImportPriceField) => {
        Emitter.emit(Event.DB_SUBMIT)
        const result = await importProductPrices(file, priceFieldValue)
        Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
        return result
    }

    return {
        updatePrices
    }
}
